/**
 * Popular Material Symbols (Outlined) for notes/folders
 * These are the newer icon set that includes many icons not in classic Material Icons
 * Use with class "material-symbols-outlined"
 */
export const MATERIAL_SYMBOLS = [
  // Documents & Notes (symbols-only icons)
  'draft',
  'note_stack',
  'note_stack_add',
  'sticky_note',
  'contract',
  'contract_edit',
  'docs_add_on',
  'docs_apps_script',
  'document_scanner',
  'quick_reference',
  'quick_reference_all',
  'newsmode',
  'ink_pen',
  'stylus_note',
  'edit_document',
  'scan_delete',
  'file_present',
  'file_copy',
  'file_open',
  'file_save',

  // Tasks & Projects
  'task',
  'task_alt',
  'add_task',
  'checklist',
  'checklist_rtl',
  'select_check_box',
  'check_box',
  'playlist_add_check',
  'assignment_add',
  'assignment_return',
  'assignment_turned_in',
  'done_outline',

  // Folders & Organization
  'folder_data',
  'folder_managed',
  'folder_shared',
  'folder_zip',
  'folder_copy',
  'folder_delete',
  'folder_off',
  'drive_folder_upload',
  'snippet_folder',
  'topic',

  // Writing & Editing
  'ink_eraser',
  'ink_highlighter',
  'ink_marker',
  'draw',
  'gesture',
  'signature',
  'stylus',
  'brush',
  'format_ink_highlighter',
  'text_select_start',
  'text_select_end',
  'text_select_move_forward_word',

  // Fantasy & RPG
  'swords',
  'shield',
  'skull',
  'pet_supplies',
  'forest',
  'camping',
  'castle',
  'fort',
  'church',
  'temple_buddhist',
  'temple_hindu',
  'mosque',
  'synagogue',
  'magic_button',
  'magic_exchange',
  'magic_tether',
  'package_2',
  'deployed_code',
  'mystery',
  'wand_stars',
  'bomb',
  'explosion',
  'destruction',

  // Characters & People
  'face_2',
  'face_3',
  'face_4',
  'face_5',
  'face_6',
  'person_2',
  'person_3',
  'person_4',
  'sprint',
  'run_circle',
  'elderly',
  'elderly_woman',
  'man',
  'man_2',
  'man_3',
  'man_4',
  'woman',
  'woman_2',
  'boy',
  'girl',
  'family_home',
  'diversity_1',
  'diversity_2',
  'diversity_3',

  // Creatures & Monsters
  'pets',
  'cruelty_free',
  'phishing',
  'raven',
  'owl',
  'hive',
  'bug_report',
  'pest_control',
  'pest_control_rodent',
  'emoji_nature',

  // Magic & Powers
  'auto_awesome',
  'auto_fix',
  'flare',
  'blur_on',
  'blur_circular',
  'flash_on',
  'electric_bolt',
  'thunderstorm',
  'tsunami',
  'volcano',
  'landslide',
  'earthquake',
  'cyclone',
  'tornado',
  'electric_bolt',
  'flare',
  'stars',
  'star_rate',
  'weather_mix',

  // Items & Equipment
  'key',
  'key_off',
  'key_vertical',
  'lock',
  'lock_open',
  'lock_person',
  'lock_clock',
  'lock_reset',
  'passkey',
  'mystery',
  'backpack',
  'luggage',
  'local_mall',
  'inventory',
  'inventory_2',
  'watch',
  'timer',
  'hourglass',
  'hourglass_top',
  'hourglass_bottom',

  // Locations & Places
  'location_city',
  'holiday_village',
  'cottage',
  'cabin',
  'house',
  'home_work',
  'apartment',
  'domain',
  'storefront',
  'warehouse',
  'factory',
  'precision_manufacturing',
  'construction',
  'foundation',
  'real_estate_agent',
  'add_home',
  'other_houses',

  // Nature & Environment
  'park',
  'nature',
  'nature_people',
  'grass',
  'yard',
  'eco',
  'compost',
  'water_drop',
  'air',
  'dew_point',
  'humidity_high',
  'humidity_low',
  'humidity_mid',
  'mist',
  'foggy',
  'snowing',
  'rainy',
  'partly_cloudy_day',
  'partly_cloudy_night',
  'sunny',
  'nightlight',
  'bedtime',
  'clear_night',

  // Status & Indicators
  'new_releases',
  'upcoming',
  'pending_actions',
  'schedule_send',
  'event_busy',
  'event_available',
  'event_note',
  'event_repeat',
  'calendar_add_on',
  'calendar_apps_script',
  'calendar_clock',
  'calendar_month',
  'calendar_today',
  'calendar_view_day',
  'calendar_view_week',
  'calendar_view_month',

  // Communication
  'forum',
  'chat',
  'chat_bubble',
  'mode_comment',
  'comment',
  'sms',
  'mms',
  'mark_chat_read',
  'mark_chat_unread',
  'speaker_notes',
  'speaker_notes_off',

  // Data & Analytics
  'analytics',
  'data_usage',
  'data_exploration',
  'pie_chart',
  'bar_chart',
  'show_chart',
  'timeline',
  'trending_up',
  'trending_down',
  'trending_flat',
  'query_stats',
  'monitoring',
  'ssid_chart',
  'stacked_line_chart',

  // Actions & Operations
  'rocket_launch',
  'rocket',
  'send',
  'share',
  'ios_share',
  'reply',
  'reply_all',
  'forward',
  'archive',
  'unarchive',
  'delete_sweep',
  'auto_delete',
  'restore_from_trash',
  'move_to_inbox',
  'markunread_mailbox',
  'outgoing_mail',
  'mark_email_read',
  'mark_email_unread',

  // Gaming specific
  'sports_esports',
  'videogame_asset',
  'stadia_controller',
  'joystick',
  'casino',
  'playing_cards',
  'domino_mask',
  'strategy',
  'rewarded_ads',
  'extension',
  'extension_off',
  'toys',
  'interests',
  'attractions',

  // Health & Stats
  'favorite',
  'heart_plus',
  'heart_minus',
  'heart_check',
  'heart_broken',
  'healing',
  'health_and_safety',
  'medical_services',
  'medication',
  'vaccines',
  'bloodtype',
  'monitor_heart',
  'vital_signs',
  'emergency',
  'sos',

  // Symbols & Glyphs
  'hexagon',
  'pentagon',
  'square',
  'circle',
  'change_history',
  'rectangle',
  'diamond',
  'interests',
  'shapes',
  'category',
  'label_important',
  'new_label',
  'sell',
  'loyalty',

  // Mind & Thinking
  'psychology',
  'psychology_alt',
  'neurology',
  'memory',
  'self_improvement',
  'spa',
  'sentiment_satisfied',
  'sentiment_dissatisfied',
  'sentiment_neutral',
  'sentiment_very_satisfied',
  'sentiment_very_dissatisfied',
  'mood',
  'mood_bad',

  // Tools & Utilities
  'build',
  'build_circle',
  'handyman',
  'hardware',
  'plumbing',
  'electrical_services',
  'carpenter',
  'construction',
  'engineering',
  'precision_manufacturing',
  'home_repair_service'
]

export default MATERIAL_SYMBOLS
